import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUser, RedirectToSignIn, SignIn } from '@clerk/clerk-react';
import { Dialog, DialogContent, Box, CircularProgress } from '@mui/material';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { isSignedIn, isLoaded } = useUser();

  // Show loading spinner while Clerk is initializing
  if (!isLoaded) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // If user is not signed in, redirect to sign-in
  if (!isSignedIn) {
    return (
      <Dialog
        open={true}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <DialogContent style={{ padding: '24px', display: 'flex', justifyContent: 'center' }}>
          <SignIn
            redirectUrl={location.pathname + location.search}
            appearance={{
              elements: {
                rootBox: {
                  width: '100%',
                },
                card: {
                  boxShadow: 'none',
                  border: 'none',
                },
              },
            }}
          />
        </DialogContent>
      </Dialog>
    );
  }

  // If user is signed in, render the protected component
  return children;
} 